import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import BarChartSkill from '../../components/BarChartSkill';
import Axios from 'axios';
import { get } from 'lodash';
import { API_HOST } from '../../consts';
import { useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Grid } from '@material-ui/core';
import TableGeneralStudentReport from './TableGeneralStudentReport';
import { GeneralStudentStyleButton } from '../avalia/style';
import InsufficientData from '../../components/InsufficientData';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import ReportProficiencyScalePageButtons from './ReportProficiencyScalePageButtons';

const ReportSkillLevelPage = ({ history }) => {
  const [habilidadeData, setHabilidadeData] = useState(null);
  const [habilidadeDataTable, setHabilidadeDataTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [matrizState, setMatrizState] = useState(1);
  const { filtrosRelatorios } = useContext(FilterRelatorioContext)

  const theme = useContext(ThemeContext);
  const [Atividades, setAtividades] = useState();
  const [AnoData, setAnoData] = useState();
  const [PeriodoData, setPeriodoData] = useState();
  const columnsHabilidade = [
    { id: 'habilidade', label: 'Habilidade', minWidth: 170, align: 'center' },
    { id: 'qtde_testada', label: 'Quantidade', minWidth: 170, align: 'center' },
    { id: 'qtde_acertos', label: 'Acertos', minWidth: 170, align: 'center' },
    {
      id: 'porc_acertos',
      label: 'Porc. Acertos',
      minWidth: 170,
      align: 'center'
    },
    { id: 'status', label: 'Status', minWidth: 170, align: 'center' }
  ];
  const fetchHabilidade = () => {
    const params = {
      tipo: 'escola-habilidade',
      escola: filtrosRelatorios.filtrosRelatorios,
      disciplina_id: filtrosRelatorios.DisciplinaID,
      periodo_ano_id: filtrosRelatorios.periodoAno,
      nr_etapa: filtrosRelatorios.dadosEtapaEscolar
    };
    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho/get_complex_data_table_dre`,
      { params }
    )
      .then((res) => {
        setHabilidadeDataTable(res.data);
      })
      .catch((err) => console.error(err));
  };
  const fetchBoletimData = () => {
    Axios.get(
      `${API_HOST}/avalia/habilidade?prova_a_cd_disciplina=${filtrosRelatorios.DisciplinaID}&cd_escola=${filtrosRelatorios.currentEscola}&serie=${filtrosRelatorios.dadosEtapaEscolar}&periodo_ano_id=${filtrosRelatorios.periodoAno}`
    )
      .then((res) => {
        fetchAnoData();
        fetchPeriodo();
        fetchAtividades();
        fetchHabilidade();
        if (res.data.results.length == 0) {
          return toast.error('Não existem dados para a consulta realizada');
        } else {
          setHabilidadeData(res.data.results);
          setLoading(true);
        }
      })
      .catch((err) =>
        toast.error('Não existem dados para a consulta realizada')
      );
  };

  const fetchAtividades = () =>
    Axios.get(`${API_HOST}/avaliacoes/avaliacao?ordering=-criado_em`)
      .then((res) => {
        setAtividades(res.data.results);
      })
      .catch((err) => console.error(err));

  const fetchAnoData = () =>
    Axios.get(`${API_HOST}/avalia/ano?id=${1}`)
      .then((res) => {
        setAnoData(res.data);
      })
      .catch((err) => console.error(err));

  const fetchPeriodo = () =>
    Axios.get(`${API_HOST}/avalia/periodo?id=${filtrosRelatorios.periodoAno} `)
      .then((res) => {
        setPeriodoData(res.data);
      })
      .catch((err) => console.error(err));

  useEffect(() => {
    fetchBoletimData();
  }, []);

  const getAtividades = (habilidade) => {
    const arrayAtv =
      Atividades &&
      Atividades.filter((atv) => atv.habilidade === habilidade).slice(0, 5);
    return arrayAtv;
  };

  const matrizSaebEnemMat = [
    {
      title: 'NÚMEROS',
      texto:
        'H01 - Reconhecer o que os números naturais indicam em diferentes situações: quantidade, ordem, medida ou código de identificação.'
    },
    {
      title: 'NÚMEROS',
      texto:
        'H02 - Identificar a posição ordinal de um objeto ou termo de uma sequência (1º, 2º, etc).'
    },
    {
      title: 'NÚMEROS',
      texto:
        'H03 - Escrever números naturais de até 4 ordens (3 ordens para o 2º ano) em sua representação por algarismos ou em língua materna OU Associar o registro numérico de números naturais de até 4 ordens (3 ordens para o 2º ano) ao registro em língua materna.'
    },
    {
      title: 'NÚMEROS',
      texto:
        'H05 - Comparar OU Ordenar números naturais de até 4 ordens (3 para 2º ano), com ou sem suporte da reta numérica.'
    },
    {
      title: 'NÚMEROS',
      texto:
        'H08 - Calcular o resultado de adições ou subtrações, envolvendo números naturais de até 4 ordens (3 ordens para o 2º ano).'
    },
    {
      title: 'NÚMEROS',
      texto:
        'H10 - Resolver problemas de adição ou de subtração, envolvendo números naturais de até 4 ordens (3 ordens para o 2º ano), com os significados de juntar, acrescentar, separar ou retirar.'
    },
    {
      title: 'ÁLGEBRA',
      texto:
        'H14 - Identificar a classificação OU Classificar objetos ou representações por figuras, por meio de atributos, tais como cor, forma e medida.'
    },
    {
      title: 'ÁLGEBRA',
      texto:
        'H16 - Inferir o padrão ou a regularidade de uma sequência de números naturais ordenados, de objetos ou de figuras.'
    },
    {
      title: 'ÁLGEBRA',
      texto:
        'H17 - Inferir os elementos ausentes em uma sequência de números naturais ordenados, de objetos ou de figuras.'
    },
    {
      title: 'GEOMETRIA',
      texto:
        'H18 - Identificar a localização OU a descrição/esboço do deslocamento de pessoas e/ou de objetos em representações bidimensionais (mapas, croquis, etc.).'
    },
    {
      title: 'GEOMETRIA',
      texto:
        'H19 - Reconhecer/nomear figuras geométricas espaciais (cubo, bloco retangular, pirâmide, cone, cilindro e esfera), relacionando-as com objetos do mundo físico.'
    },
    {
      title: 'GEOMETRIA',
      texto:
        'H20 - Reconhecer/nomear figuras geométricas planas (círculo, quadrado, retângulo e triângulo).'
    }
  ];
  const matrizSesiMat = [
    {
      title: '-',
      texto:
        'SESI.EF04MA15.s.15 - Determinar o número desconhecido que torna verdadeira uma igualdade que envolve as operações fundamentais com números naturais.'
    },
    {
      title: '-',
      texto:
        'SESI.EF08MA01.s.02 - Efetuar cálculos com potências de expoentes inteiros e aplicar esse conhecimento na representação de números em notação científica.'
    },
    {
      title: '-',
      texto:
        'SESI.EF06MA12.s.15 - Fazer estimativas de quantidades e aproximar números para múltiplos da potência de 10 mais próxima.'
    },
    {
      title: '-',
      texto:
        'SESI.EF06MA20.s.27 - Identificar características dos quadriláteros, classificá-los em relação a lados e a ângulos e reconhecer a inclusão e a intersecção de classes entre eles.'
    },
    {
      title: '-',
      texto:
        'SESI.EF05MA03.s.06 - Identificar e representar frações (menores e maiores que a unidade), associando-as ao resultado de uma divisão ou à ideia de parte de um todo, utilizando a reta numérica como recurso.'
    },
    {
      title: '-',
      texto:
        'SESI.EF04MA11.s.11 - Identificar regularidades em sequências numéricas compostas por múltiplos de um número natural.'
    },
    {
      title: '-',
      texto:
        'SESI.EF03MA10.s.10 - Identificar regularidades em sequências ordenadas de números naturais, resultantes da realização de adições ou subtrações sucessivas, por um mesmo número, descrever uma regra de formação da sequência e determinar elementos faltantes ou seguintes.'
    },
    {
      title: '-',
      texto:
        'SESI.EF08MA20.s.26 - Reconhecer a relação entre um litro e um decímetro cúbico e a relação entre litro e metro cúbico, para resolver problemas de cálculo de capacidade de recipientes.'
    },
    {
      title: '-',
      texto:
        'SESI.EF08MA14.a.16 - Reconhecer as características de triângulos e quadriláteros para sua classificação.'
    },
    {
      title: '-',
      texto:
        'SESI.EF08MA22.s.28 - Calcular a probabilidade de eventos, com base na construção do espaço amostral, utilizando o princípio multiplicativo, e reconhecer que a soma das probabilidades de todos os elementos do espaço amostral é igual a 1.'
    },
    {
      title: '-',
      texto:
        'SESI.EF01MA20.s.20 - Classificar eventos envolvendo o acaso, tais como “acontecerá com certeza”, “talvez aconteça” e “é impossível acontecer”, em situações do cotidiano.'
    },
    {
      title: '-',
      texto:
        'SESI.EF01MA20.s.20 - Classificar eventos envolvendo o acaso, tais como “acontecerá com certeza”, “talvez aconteça” e “é impossível acontecer”, em situações do cotidiano.'
    }
  ];
  const matrizSaebEnemLing = [
    {
      title: 'LEITURA',
      texto:
        'H10 - Identificar, em textos versificados, rimas, sonoridades, jogos de palavras, palavras, expressões, comparações, relacionando-as com sensações e associações.'
    },
    {
      title: 'LEITURA',
      texto:
        'H05 - Compreender o efeito de sentido decorrente do uso de diferentes pontuações (ponto final, de interrogação, de exclamação ou dois pontos).'
    },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      texto:
        'H01 - Relacionar elementos sonoros das palavras com sua representação escrita.'
    },
    {
      title: 'LEITURA',
      texto: 'H07 - Localizar informações explícitas em textos.'
    },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      texto:
        'H04 - Segmentar palavras em sílabas e/ou remover e substituir sílabas iniciais, mediais ou finais para criar novas palavras.'
    },
    { title: 'LEITURA', texto: 'H13 - Distinguir fatos de opiniões em textos' },
    {
      title: 'APROPRIAÇÃO DO SISTEMA DE ESCRITA ALFABÉTICA',
      texto:
        'H02 - Ler e escrever corretamente as palavras com sílabas CV, V, CVC, CCV, identificando que existem vogais em todas as sílabas.'
    }
  ];
  const matrizSesiLinguagens = [
    {
      title: '-',
      texto:
        'SESI.EF06LP03.06.s.36 - Analisar diferenças de sentido entre palavras de uma série sinonímica.'
    },
    {
      title: '-',
      texto:
        'SESI.EF08LP05.09.s.51 - Analisar processos de formação de palavras por composição (aglutinação e justaposição), apropriando-se de regras básicas de uso do hífen em palavras compostas.'
    },
    {
      title: '-',
      texto:
        'SESI.EF89LP37.09.s.48 - Analisar os efeitos de sentido do uso de figuras de linguagem como ironia, eufemismo, antítese, aliteração, assonância, dentre outras.'
    },
    {
      title: '-',
      texto:
        'SESI.EF08LP05.09.s.51 - Analisar processos de formação de palavras por composição (aglutinação e justaposição), apropriando-se de regras básicas de uso do hífen em palavras compostas.'
    },
    {
      title: '-',
      texto:
        'SESI.EF09LP07.09.s.16 - Comparar o uso de regência verbal e regência nominal na norma-padrão com seu uso no português brasileiro coloquial oral.'
    },
    {
      title: '-',
      texto:
        'SESI.EF89LP23.09.s.36 - Analisar, em textos argumentativos, reivindicatórios e propositivos, os movimentos argumentativos utilizados (sustentação, refutação e negociação), avaliando a força dos argumentos utilizados.'
    },
    {
      title: '-',
      texto:
        'SESI.EF04LP05.04.s.54 - Identificar a função na leitura e usar, adequadamente, na escrita ponto final, de interrogação, de exclamação, dois-pontos e travessão em diálogos (discurso direto), vírgula em enumerações e em separação de vocativo e de aposto.'
    },
    {
      title: '-',
      texto:
        'SESI.EF09LP07.09.s.16 - Comparar o uso de regência verbal e regência nominal na norma-padrão com seu uso no português brasileiro coloquial oral.'
    },
    {
      title: '-',
      texto:
        'SESI.EF04LP05.04.s.54 - Identificar a função na leitura e usar, adequadamente, na escrita ponto final, de interrogação, de exclamação, dois-pontos e travessão em diálogos (discurso direto), vírgula em enumerações e em separação de vocativo e de aposto.'
    },
    {
      title: '-',
      texto:
        'SESI.EF02LP10.02.s.72 - Identificar sinônimos de palavras de texto lido, determinando a diferença de sentido entre eles, e formar antônimos de palavras encontradas em texto lido pelo acréscimo do prefixo de negação in-/im-.'
    },
    {
      title: '-',
      texto:
        'SESI.EF09LP07.09.s.16 - Comparar o uso de regência verbal e regência nominal na norma-padrão com seu uso no português brasileiro coloquial oral.'
    },
    {
      title: '-',
      texto:
        'SESI.EF02LP10.02.s.72 - Identificar sinônimos de palavras de texto lido, determinando a diferença de sentido entre eles, e formar antônimos de palavras encontradas em texto lido pelo acréscimo do prefixo de negação in-/im-.'
    }
  ];
  const titulo = [
    'Linguagens, Códigos e suas Tecnologias',
    'Matemática e suas Tecnologias'
  ];
  const etapa = {
    2: 'EF 2º ano',
    3: 'EF 3º ano',
    4: 'EF 4º ano',
    5: 'EF 5º ano',
    6: 'EF 6º ano',
    7: 'EF 7º ano',
    8: 'EF 8º ano',
    9: 'EF 9º ano',
    11: 'EM 1ª série',
    12: 'EM 2ª série',
    13: 'EM 3ª série'
  };

  const allKeys = ['AB', 'B', 'AD', 'AV', 'I', 'II', 'III', 'IV', 'V'];
  const colors = {
    AB: '#FFCECE',
    B: '#FFE74F',
    AD: '#BFEEA6',
    AV: '#ABD4EC',
    I: '#FFCECE',
    II: '#FFE74F',
    III: '#BFEEA6',
    IV: '#ABD4EC',
    V: '#C4ABEC',
    'Abaixo do básico': '#FFCECE',
    'Abaixo do Básico': '#FFCECE',
    Básico: '#FFE74F',
    Adequado: '#BFEEA6',
    Avançado: '#ABD4EC',
    'Grupo 1': '#FFCECE',
    'Grupo 2': '#FFE74F',
    'Grupo 3': '#BFEEA6',
    'Grupo 4': '#ABD4EC',
    'Grupo 5': '#C4ABEC',
    base: '#F7F7F7',
    Aluno: '#FFFFFF',
    Escola: '#47BEF3',
    Turma: '#737272',
    DR: '#B972F1',
    Estado: '#001AFF'
  };

  const cdDisciplina =
    habilidadeData && get(habilidadeData[0], 'prova_a_cd_disciplina');
  const matriz =
    matrizState != 1 && matrizState == 2
      ? cdDisciplina == 1
        ? matrizSaebEnemLing
        : matrizSaebEnemMat
      : cdDisciplina == 1
        ? matrizSesiLinguagens
        : matrizSesiMat;
  const host = window.location.hostname;

  return (
    <>
      <div
        className="card-header"
        style={{
          width: '100%',
          marginBottom: '-0.7rem',
          backgroundColor: '#f7f7f7',
          borderRadius: '10px'
        }}
      >
        <h1
          style={{
            fontFamily: 'Quicksand',
            fontSize: '24px',
            color: '#292929',
            fontWeight: 'bold'
          }}
        >
          Relatório Nível de Habilidades
        </h1>
        <span
          style={{
            fontSize: '14px',
            color: '#292929',
            fontWeight: 500,
            fontFamily: 'Quicksand'
          }}
        >
          Diagnóstico de proficiência por escola
        </span>
        <hr
          style={{
            background: '#bebebe',
            width: '100%',
            height: '1px',
            borderRadius: '1px'
          }}
        />
      </div>
      <div
        className="card-body"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <div className="infos__school">
          <h2>Habilidades a serem desenvolvidas</h2>
          <span className="example-hability">
            Os dados abaixo dizem respeito ao desempenho dos
            estudantes dessa escola em cada habilidade testada.
            Demonstra a porcentagem de acertos de cada grupo de
            proficiência em uma habilidade.
          </span>
        </div>

        <div
          className="school__material"
          style={{ color: `${theme.primary}` }}
        >
          <span>
            {titulo[habilidadeData ? cdDisciplina - 1 : '']}
          </span>
        </div>
        <div
          className="table-proficiency"
          style={{
            backgroundColor: `${theme.primary}`
          }}
        >
          <span
            style={{
              fontSize: '16px',
              color: '#fff',
              fontWeight: 600,
              textTransform: 'uppercase'
            }}
          >
            {
              etapa[
              habilidadeData ? get(habilidadeData[0], 'serie') : ''
              ]
            }
          </span>
        </div>
        <hr className="pro-hr" />
        <Grid item container xs={12} sm={12} md={12}>
          {/* <Grid item xs={12}>
            {habilidadeDataTable && habilidadeDataTable.length > 0 ? (
              <TableGeneralStudentReport
                title="Habilidade"
                columns={columnsHabilidade}
                rows={habilidadeDataTable && habilidadeDataTable}
                pagination={true}
                tourSelector="tabela-habilidade"
              />
            ) : (
              <div style={{ width: '100%', height: 'auto' }}>
                {' '}
                <InsufficientData />
              </div>
            )}
          </Grid> */}
        </Grid>
        {habilidadeData && matrizState == 1
          ? habilidadeData.map((dataHability) => {
            const sugestoesAtv = getAtividades(
              get(dataHability, 'id', '')
            );
            return (
              <div style={{ width: '100%' }}>
                <div className="proeficiency__infos">
                  <>
                    <div className="axis__infos">
                      <div className="axis__text">
                        <span>
                          Eixo de Conhecimento:{' '}
                          <span
                            style={{
                              color: `${theme.primary}`,
                              marginLeft: '1rem',
                              fontWeight: '500'
                            }}
                          >
                            {get(dataHability, 'eixo', '')}
                          </span>
                        </span>
                      </div>

                      <div className="habilidade">
                        <span>Habilidade: </span>
                        <span className="skill-text">
                          {get(dataHability, 'habilidade', '')}
                        </span>
                      </div>

                      <div className="intervencao">
                        <span>Sugestões de Atividades: </span>
                        {sugestoesAtv &&
                          sugestoesAtv.length > 0 ? (
                          <>
                            {sugestoesAtv.map((atv) => (
                              <Link
                                to={`/instrumentos-cognitivos/${atv.id}`}
                              >
                                {atv.nome}
                              </Link>
                            ))}
                          </>
                        ) : (
                          <b>
                            Ainda não há atividades relacionadas à
                            esta habilidade
                          </b>
                        )}
                      </div>

                      <GeneralStudentStyleButton>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'flex-end',
                            marginBottom: '1rem',
                            marginTop: '1rem'
                          }}
                        >
                          {/* <button
                                      className='button-primary'
                                      style={{
                                        border: 'none',
                                        fontSize: '1rem',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        borderRadius: '20px',
                                        boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                        padding: '4px 16px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                      }}
                                      onClick={() => {
                                        history.push(`/diagnostico-intervencao/${match.params.escolaId}/habilidade/${dataHability.id}/disciplina/${cdDisciplina}`)
                                      }}
                                    >
                                      Realizar Intervenção Pedagógica
                                    </button> */}
                        </div>
                      </GeneralStudentStyleButton>
                    </div>
                  </>
                  <div className="graphic">
                    <BarChartSkill
                      data={dataHability.porc_acertos_hab}
                      keys={allKeys}
                      colors={colors}
                    />
                  </div>
                </div>
              </div>
            );
          })
          : habilidadeData &&
          matriz.map((item, i) => {
            const dataHability = habilidadeData[i];
            const sugestoesAtv = getAtividades(
              get(dataHability, 'id', '')
            );

            return (
              <div style={{ width: '100%' }}>
                <div className="proeficiency__infos">
                  <>
                    <div className="axis__infos">
                      <div className="axis__text">
                        <span>
                          Eixo de Conhecimento esse:{' '}
                          <span
                            style={{
                              color: `${theme.primary}`,
                              marginLeft: '1rem',
                              fontWeight: '500'
                            }}
                          >
                            {item.title}
                          </span>
                        </span>
                      </div>

                      <div className="habilidade">
                        <span>Habilidade: </span>
                        <span className="skill-text">
                          {item.texto}
                        </span>
                      </div>

                      <div className="intervencao">
                        <span>Sugestões de Atividades: </span>
                        {sugestoesAtv && sugestoesAtv.length > 0 ? (
                          <>
                            {sugestoesAtv.map((atv) => (
                              <Link
                                to={`/instrumentos-cognitivos/${atv.id}`}
                              >
                                {atv.nome}
                              </Link>
                            ))}
                          </>
                        ) : (
                          <b>
                            Ainda não há atividades relacionadas à
                            esta habilidade
                          </b>
                        )}
                      </div>

                      <GeneralStudentStyleButton>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'flex-end',
                            marginBottom: '1rem',
                            marginTop: '1rem'
                          }}
                        >
                          <button
                            className="button-primary"
                            style={{
                              border: 'none',
                              fontSize: '1rem',
                              fontWeight: '600',
                              cursor: 'pointer',
                              borderRadius: '20px',
                              boxShadow:
                                '2px 4px 5px rgba(58, 58, 58, 0.25)',
                              padding: '4px 16px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center'
                            }}
                            onClick={() => {
                              history.push(
                                `/diagnostico-intervencao/${filtrosRelatorios.currentEscola}/habilidade/${dataHability.id}/disciplina/${cdDisciplina}`
                              );
                            }}
                          >
                            Realizar Intervenção Pedagógica
                          </button>
                        </div>
                      </GeneralStudentStyleButton>
                    </div>
                  </>
                  {dataHability && (
                    <div className="graphic">
                      <BarChartSkill
                        data={dataHability.porc_acertos_hab}
                        keys={allKeys}
                        colors={colors}
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        <ReportProficiencyScalePageButtons />
      </div>
    </>
  );
};

export default withRouter(ReportSkillLevelPage);
